import React from 'react';

import { Container } from 'reactstrap';

//Import Breadcrumb
// import UserPanel from './CountrysPanel';
import Countries from './Countries';
import Breadcrumbs from "../../components/Common/Breadcrumb";


const Country = () => {
    document.title = "Countries |Onfon Group Legal Dept";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Menu" breadcrumbItem="Country Page" />
                    <div className="row">
                        {/* <UserPanel /> */}
                        <span width="100px"></span>
                        <Countries />
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Country;